<template>
  <div
    class="Avatar"
    :style="style">
    <span v-if="!avatar">
      {{ initials }}
    </span>
  </div>
</template>

<script>
export default {
  computed: {
    avatar() {
      return this.$store.getters["profile"].avatar;
    },

    initials() {
      const profile = this.$store.getters["profile"];
      if (profile && profile.firstName && profile.lastName) {
        return `${profile.firstName[0]}${profile.lastName[0]}`;
      }
      return "";
    },

    style() {
      return {
        backgroundImage: `url(${this.avatar}), url(${this.defaultProfileImage})`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.Avatar {
  height: 2rem;
  width: 2rem;
  display: flex;
  overflow: hidden;
  font-size: 1rem;
  align-items: center;
  line-height: 1;
  justify-content: center;

  border-radius: 50%;
  background-color: var(--red-pink);

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
